module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-editorial-blacklivesmatter-4-85bc31353345d112b5eff883435478cf.png";